module.exports = __webpack_public_path__ + "static/media/CircularStd-Book.60f92783.eot";